<template>
  <div class="row px-3">
    <HeaderBreadcrumbs :items="[
      { label: 'Organization' },
    ]" title="All Organization" />
    <div class="bg-white w-full">
      <div class="bg-white w-full rounded-lg my-0 px-4 pt-3 pb-3">
        <div class="flex justify-between items-center">
          <div class="relative">
                    <svg  class="w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 left-3"
                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                        viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                            d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
                    </svg>
                    <input class="bg-white rounded-lg py-2 px-11 border w-96"
                        placeholder='Search Organization Name' v-model="filter" @input="asyncFind" />
                    <button v-if="filter"
                        class="absolute top-1/2 right-5 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        @click="actionReset" title="Clear search">
                        ✕
                    </button>

                </div>
          <div class="relative flex justify-end">
          <button
            class="text-gray-500 mr-3 bg-blue-700 border focus:outline-none font-medium rounded-lg text-sm px-2 py-2.5 text-center"
            type="button">
            <router-link class="text-white px-1 py-2" :to="{ path: 'organization/create' }">
              <i class="fa fa-plus"></i> Add New
            </router-link>
          </button>
          <t-dropdown>
            <div slot="trigger" slot-scope="{ mousedownHandler, focusHandler, blurHandler, keydownHandler }"
              class="flex">
              <button
                class="flex items-center justify-center h-10 px-3 py-2.5 text-gray-500 bg-white border border-gray-400 rounded-lg"
                @mousedown="mousedownHandler" @focus="focusHandler" @blur="blurHandler" @keydown="keydownHandler">
                <svg class="w-4 h-4 mr-1 text-gray-600 dark:text-white" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z" />
                </svg>
                Filter
                <svg class="w-5 h-5 ml-1 text-gray-600 fill-current" viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <polygon
                    points="9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8" />
                </svg>
              </button>
            </div>
            <div class="w-custom bg-white absolute -right-2 pt-2 pb-3 border rounded-lg"
              slot-scope="{ hide, blurHandler }">
              <div
                class="block w-full px-4 py-2 text-sm text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:bg-gray-100"
                role="menuitem">
                <div class="flex justify-between mb-3 mt-2">
                  <div>Filter</div>
                  <div @click="hide">
                    <svg class="w-4 h-4 text-gray-800 dark:text-white cursor-pointer" aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M6 18 17.94 6M18 18 6.06 6" />
                    </svg>
                  </div>
                </div>
                <div class="grid gap-4 grid-cols-2">
                  <div>
                    <label class="text-gray-600 font-semibold mb-3">Organization Type</label>
                    <StatusFilterComponent v-model="type" :options="typeOptions"
                      :defaultText="'Select Organization Type'" />
                  </div>


                  <div>
                    <label class="text-gray-600 font-semibold mb-3">Status</label>
                      <StatusFilterComponent
                      v-model="status"
                      :options="statusOptions"
                      :defaultText="`Select Status`"
                       />
                    </div>
                </div>
                <div class="mt-3">
                  <button class="border bg-blue-500 px-4 py-2 text-white rounded-lg" @click="handleFilter"
                    @blur="blurHandler">
                    Filter
                  </button>
                  <button class="border bg-white text-gray-500 px-4 py-2 rounded-lg ml-2" @click="asyncClearFind()"
                    @blur="blurHandler">Reset</button>
                </div>
              </div>
            </div>
          </t-dropdown>
        </div>
        </div>
      </div>
      <Table
      :headers="headers"
      :data="organization"
      :row-key="['name', 'legal_name', 'accounting_id', 'type', 'status', 'created']"
      :current-page="currentPage"
      :isLoading="isLoading"
      :per-page="20">
        <template #header-joinDate="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
            </button>
          </div>
        </template>
        <!-- slot status -->
        <template #status="{ value }">
          <span class="px-2 py-1 rounded-lg text-xs font-medium capitalize" :class="statusColor(value)">
            {{ value }}
          </span>
        </template>
        <!-- slot Join Date -->
        <template #created="{ value }">
          <span>{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
        <!-- slot actions -->
        <template #actions="{ row }">
          <router-link :to="{ path: 'organization/edit/' + row.id }"
            class="link text-gray-600 align-middle items-center flex justify-center">
            <svg class="w-6 h-6 text-gray-600 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd"
                d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
                clip-rule="evenodd" />
              <path fill-rule="evenodd"
                d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
                clip-rule="evenodd" />
            </svg>

          </router-link>
        </template>
      </Table>
      <div v-if="!isLoading && organization.length  " class="flex bg-white justify-between pl-3 pr-3 pt-4 mb-0 border-t border-gray-100 mt-1">
          <div class="font-semibold">
            <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
              class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
          </div>
          <div class="mb-2">
            <t-pagination :total-items="Number(totalRows)" :per-page="perPage" v-model="currentPage"
              @change="onClickPage" />
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import StatusFilterComponent from '@/components/form/StatusFilterComponent.vue'
import Table from '@/components/form/table.vue'
export default {
  name: 'Organization',
  components: {
    HeaderBreadcrumbs,
    StatusFilterComponent,
    Table
  },
  data() {
    return {
      filter: '',
      items_search: [],
      currentPage: 1,
      perPage: 20,
      isDropdownVisible: false,
      isLoadingSearch: false,
      sortOrder: 'desc',
      debounce: null,
      fields: [
        { key: 'No', label: 'No.', thStyle: { maxWidth: '15px' } },
        { key: 'name', label: 'Name' },
        { key: 'type', label: 'Type' },
        { key: 'status', label: 'Status' },
        {
          key: 'created',
          label: 'Join Date',
          formatter: function (value) {
            return value != null ? moment(value).format('DD-MM-YYYY') : '-';
          },
        },
      ],
      type: 'all-type',
      status: 'all-status',
      typeOptions: [
        { value: 'all-type', text: 'All Type' },
        { value: 'vendor', text: 'Vendor' },
        { value: 'shared library', text: 'Shared Library' },
      ],
      statusOptions: [
        { value: 'all-status', text: 'All Status' },
        { value: 'new', text: 'New' },
        { value: 'approved', text: 'Approved' },
        { value: 'clear', text: 'Clear' },
        { value: 'banned', text: 'Banned' },
      ],
      headers: [
        { label: 'No', key: 'no' },
        { label: 'organization name', key: 'name' },
        { label: 'Legal Name', key: 'legal_name' },
        { label: 'Accounting Id', key: 'accounting_id' },
        { label: 'Type', key: 'type' },
        { label: 'Status', key: 'status' },
        { label: 'Join Date', key: 'created', sortable: true, slotHeader: 'header-joinDate' },
      ]
    };
  },
  watch: {
    currentPage: function () {
      this.getOrganization();
    },
    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Organization | Content Management System Ebooks Gramedia.com';
      },
    },
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.organization.isLoading,
      isError: (state) => state.organization.isError,
      totalRows: (state) => state.organization.totalRows,
      organization: (state) => state.organization.items,
    }),
  },
  mounted() {
    this.getOrganization();
  },
  methods: {
    ...mapActions('organization', [
      'fetchOrganization',
      'findOrganization',
      'fetchOrganizationById',
    ]),

    customLabel({ name }) {
      if (name) {
        return name;
      } else {
        return 'find organization...';
      }
    },
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    statusColor(status) {
      switch (status) {
        case 'new':
          return 'bg-blue-100 text-blue-700';
        case 'approved':
          return 'bg-green-100 text-green-700';
        case 'clear':
          return 'bg-gray-200 text-gray-800';
        case 'banned':
          return 'bg-red-100 text-red-700';
        default:
          return 'bg-gray-100 text-gray-600';
      }
    },
    asyncClearFind() {
      this.type = '';
      this.status = ''
      this.filter = ''
      this.currentPage = 1
      this.getOrganization();
    },
    handleFilter() {
      this.onTypeChange()
    },
    formatDate(tgl) {
      return {
        date: moment(tgl).format('DD MMM YY'),
        time: moment(tgl).format('HH:mm:ss')
      };
    },
    getOrganization() {
      let payload = {
        q:this.filter,
        type: this.type,
        status: this.status,
        page: this.currentPage,
        limit: this.perPage,
      };
      this.fetchOrganization(payload);
    },

    asyncFind() {
      this.isLoadingSearch = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        let payload = {
          q:this.filter,
          page: this.currentPage,
          limit: this.perPage,
        };

        this.fetchOrganization(payload)
          .then((response) => {
            this.items_search = response.data.data.rows;
            this.isLoadingSearch = false;
          })
          .catch(() => {
            this.isLoadingSearch = false;
          });
      }, 600);
    },

    actionFindOne(query) {
      this.fetchOrganizationById(query);
    },
    sortBy(sortByCreate) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      let payload = {
        q:this.filter,
        type: this.type,
        status: this.status,
        page: this.currentPage,
        limit: this.perPage,
        order_by:sortByCreate,
        sort:this.sortOrder
      };

      this.fetchOrganization(payload);
    },
  async  onClickPage(page) {
      this.currentPage = page;
    },
    actionReset() {
      this.filter=''
      this.currentPage = 1
      this.getOrganization()
    },
    onTypeChange() {
      let payload = {
        q:this.filter,
        type: this.type,
        status: this.status,
        page: this.currentPage = 1,
        limit: this.perPage,
      };
      this.fetchOrganization(payload);
    },
  },
};
</script>
<style scoped>
.w-custom {
  width: 620px;
}
</style>
